import { render, staticRenderFns } from "./ActionConfirmation.vue?vue&type=template&id=1570f9d6&scoped=true"
import script from "./ActionConfirmation.vue?vue&type=script&lang=js"
export * from "./ActionConfirmation.vue?vue&type=script&lang=js"
import style0 from "./ActionConfirmation.vue?vue&type=style&index=0&id=1570f9d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1570f9d6",
  null
  
)

export default component.exports